module.exports = {"generalDocs":{"title":"Allgemeine Dokumente"},"popover":"Füge hier allgemeine Dokumente hinzu.","addDocumentButton":"Dokument hinzufügen +","meta":"Dokumente"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/documents.json
// module id = InXV
// module chunks = 1